import { render, staticRenderFns } from "./scoreConfigList.vue?vue&type=template&id=7669ee97&scoped=true"
import script from "./scoreConfigList.vue?vue&type=script&lang=js"
export * from "./scoreConfigList.vue?vue&type=script&lang=js"
import style0 from "./scoreConfigList.vue?vue&type=style&index=0&id=7669ee97&prod&lang=css"
import style1 from "./scoreConfigList.vue?vue&type=style&index=1&id=7669ee97&prod&scoped=true&lang=css"
import style2 from "./scoreConfigList.vue?vue&type=style&index=2&id=7669ee97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7669ee97",
  null
  
)

export default component.exports